export default {
  title: 'Terminal',
  stats: {
    terminal_battery_level: 'Nivel de batería',
    terminal_battery_state: 'Estado de carga',
    auto_accept_orders: 'Aceptar pedidos automáticamente',
  },
  auto_accept_orders_modal: {
    title: '¿Estás seguro de que quieres aceptar pedidos automáticamente?',
    buttons: {
      activate: 'Activar',
      cancel: 'Cancelar',
    },
  },
  feedback: {
    update_success: 'Actualizado correctamente',
    update_failed: 'Error al actualizar la información. Por favor, inténtalo de nuevo.',
  },
};
